import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';

const Logout = () => {
    const navigate = useNavigate();
    const [isLoggedOut, setIsLoggedOut] = useState(false);

    useEffect(() => {
        logoutUser();
    }, []);

    async function logoutUser() {

        try{
            await Auth.signOut();

          
            console.log('User Logged Out');
            setIsLoggedOut(true);
            navigate('/login');
            
        } catch {
            console.log('User not logged out');
            setIsLoggedOut(false);
        }

    };

    return <div>Logging out...</div>;
};

export default Logout;

